import { configureStore } from "@reduxjs/toolkit"
import { Provider } from "react-redux"

import authReducer from "./auth.jsx"
import chatReducer from "./chat.jsx"
import companyReducer from "./company.jsx"

const store = configureStore({
  reducer: {
    auth: authReducer,
    chat: chatReducer,
    company: companyReducer,
  },
})

export const ReduxProvider = ({ children }) => {
  return <Provider store={store}>{children}</Provider>
}
